/**
 * Section - a collapsible card for progressive disclosure across the app. The
 * title and an optional one-line summary stay visible; detail expands on tap,
 * so screens stay calm for basic users while advanced controls sit one tap
 * away. `defaultOpen` keeps the essential section expanded.
 *
 * Author: Mare Greyling (Thevertex) <mare.greyling@gmail.com> - https://mare-greyling.com
 */
import { useState } from 'react';

export default function Section({ id, title, subtitle, icon, badge, dataGuide, defaultOpen = false, children }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <section id={id} className="card !p-0 overflow-hidden mb-3 scroll-mt-20" data-guide={dataGuide}>
      <button type="button" aria-expanded={open}
              className="w-full flex items-center gap-3 px-4 py-3 text-left hover:bg-white/[0.02] transition"
              onClick={() => setOpen((o) => !o)}>
        {icon && (
          <span className="w-9 h-9 shrink-0 rounded-xl bg-surface2 border border-edge grid place-items-center text-lg">
            {icon}
          </span>
        )}
        <span className="flex-1 min-w-0">
          <span className="font-bold block truncate">{title}</span>
          {subtitle && <span className="text-xs text-slate-500 block truncate">{subtitle}</span>}
        </span>
        {badge}
        <span className="text-slate-500 text-sm shrink-0">{open ? '\u25be' : '\u25b8'}</span>
      </button>
      {open && <div className="px-4 pb-4 pt-1 border-t border-edge">{children}</div>}
    </section>
  );
}
